import { collection, query, getDocs } from "firebase/firestore";
import { db } from "@/fb";
import { config } from "@/utils/configuration/config";

export default class RangesForTypeRepoFirebase {
  constructor() {
    console.log("Construyendo RangesForTypeRepoFirebase");
  }

  async getRangesForTypeShipType(ref, callback) {
    const q = query(collection(db, config.firebaseConfig.shipTypesCollectionName, ref, "Ranges"));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      const data = doc.data();
      //console.log("Document data:", data);
      callback(ref, data);
    });
  }
}
